module.exports = __webpack_public_path__ + "static/img/next_q_btn_before.d6b60113.png";